import React from 'react';

const STEPS = [
  { id: 'recepcion',       step: 1, icon: '📥', label: 'Recepción MP',      desc: 'Registrar ingreso de proveedor' },
  { id: 'lotes',           step: 2, icon: '🏪', label: 'Lotes en bodega',   desc: 'Ver y gestionar lotes activos' },
  { id: 'stock',           step: 3, icon: '📊', label: 'Stock disponible',  desc: 'Inventario calculado en tiempo real' },
  { id: 'pedidos',         step: 4, icon: '🛒', label: 'Pedido a bodega',   desc: 'Solicitar insumos para cocina' },
  { id: 'recepcion-cocina',step: 5, icon: '✅', label: 'Recepción cocina',  desc: 'Confirmar insumos recibidos' },
];

const ANALYSIS = [
  { id: 'pipeline', icon: '🔀', label: 'Pipeline de lotes',   desc: 'Flujo visual por lote' },
  { id: 'historial', icon: '📑', label: 'Historial completo', desc: 'Trazabilidad por lote o producto' },
];

const CONFIG = [
  { id: 'maestro', icon: '🗂', label: 'Maestro SAP', desc: 'Catálogo de materiales' },
];

function LogoCA() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
      <rect width="36" height="36" rx="9" fill="rgba(255,255,255,0.18)" />
      <path d="M7 27 L14 11 L18 20 L22 11 L29 27" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <rect x="25" y="23" width="5" height="5" rx="1.5" fill="#F5A623" />
    </svg>
  );
}

function NavItem({ item, current, onNav, showStep }) {
  const active = current === item.id;
  return (
    <div
      onClick={() => onNav(item.id)}
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '8px 10px', borderRadius: 9, cursor: 'pointer',
        background: active ? 'var(--primary-light)' : 'transparent',
        border: active ? '1.5px solid var(--primary-mid)' : '1.5px solid transparent',
        transition: 'all 0.15s', marginBottom: 2,
      }}
    >
      {/* Número de paso o ícono */}
      <div style={{
        width: 32, height: 32, borderRadius: 8, flexShrink: 0,
        background: active ? 'var(--primary)' : 'var(--bg)',
        border: active ? 'none' : '1.5px solid var(--border)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: showStep ? 12 : 15,
        fontWeight: 800,
        color: active ? '#fff' : 'var(--text3)',
        fontFamily: showStep ? 'var(--font-display)' : 'inherit',
      }}>
        {showStep ? item.step : item.icon}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 13, fontWeight: active ? 700 : 600,
          color: active ? 'var(--primary)' : 'var(--text)',
          display: 'flex', alignItems: 'center', gap: 5,
        }}>
          {showStep && <span style={{ fontSize: 11 }}>{item.icon}</span>}
          {item.label}
        </div>
        <div style={{ fontSize: 10.5, color: active ? 'var(--primary)' : 'var(--text3)', marginTop: 1, opacity: 0.85 }}>
          {item.desc}
        </div>
      </div>
    </div>
  );
}

export default function Sidebar({ current, onNav }) {
  return (
    <nav style={{
      width: 248, minHeight: '100vh', background: 'var(--surface)',
      borderRight: '1px solid var(--border)', display: 'flex',
      flexDirection: 'column', flexShrink: 0, position: 'sticky',
      top: 0, height: '100vh', overflowY: 'auto', boxShadow: 'var(--shadow-sm)',
    }}>
      {/* Marca */}
      <div style={{ borderBottom: '1px solid var(--border)' }}>
        <div style={{ background: 'var(--primary)', padding: '16px 18px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <LogoCA />
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 13, fontWeight: 800, color: '#fff', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
              Caja Los Andes
            </div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.75)', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', marginTop: 1 }}>
              TraceOps · Trazabilidad
            </div>
          </div>
        </div>

        {/* Dashboard */}
        <div style={{ padding: '10px 10px 6px' }}>
          <NavItem item={{ id: 'dashboard', icon: '◈', label: 'Dashboard', desc: 'Resumen, alertas y métricas' }} current={current} onNav={onNav} showStep={false} />
        </div>
      </div>

      <div style={{ padding: '10px 10px', flex: 1 }}>

        {/* Proceso principal */}
        <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '1.2px', padding: '8px 10px 6px', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>Proceso de trazabilidad</span>
          <span style={{ background: 'var(--primary-light)', color: 'var(--primary)', borderRadius: 20, padding: '1px 7px', fontSize: 9, fontWeight: 800 }}>5 pasos</span>
        </div>

        {/* Línea guía del flujo */}
        <div style={{ margin: '0 10px 8px', padding: '8px 10px', background: 'var(--bg)', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 4, border: '1px solid var(--border)' }}>
          {STEPS.map((s, i) => (
            <React.Fragment key={s.id}>
              <div
                onClick={() => onNav(s.id)}
                title={s.label}
                style={{
                  width: 22, height: 22, borderRadius: 6, cursor: 'pointer',
                  background: current === s.id ? 'var(--primary)' : 'var(--surface)',
                  border: `1.5px solid ${current === s.id ? 'var(--primary)' : 'var(--border2)'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 10, fontWeight: 800,
                  color: current === s.id ? '#fff' : 'var(--text3)',
                  fontFamily: 'var(--font-display)',
                  transition: 'all 0.15s',
                }}
              >
                {s.step}
              </div>
              {i < STEPS.length - 1 && (
                <div style={{ flex: 1, height: 1.5, background: 'var(--border)', borderRadius: 1 }} />
              )}
            </React.Fragment>
          ))}
        </div>

        {STEPS.map(item => (
          <NavItem key={item.id} item={item} current={current} onNav={onNav} showStep={true} />
        ))}

        {/* Análisis */}
        <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '1.2px', padding: '14px 10px 6px' }}>
          Análisis y trazabilidad
        </div>
        {ANALYSIS.map(item => (
          <NavItem key={item.id} item={item} current={current} onNav={onNav} showStep={false} />
        ))}

        {/* Configuración */}
        <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '1.2px', padding: '14px 10px 6px' }}>
          Configuración
        </div>
        {CONFIG.map(item => (
          <NavItem key={item.id} item={item} current={current} onNav={onNav} showStep={false} />
        ))}
      </div>

      {/* Usuario */}
      <div style={{ padding: '12px 14px', borderTop: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8, background: 'var(--bg)' }}>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 12, color: '#fff', flexShrink: 0 }}>JR</div>
          <div>
            <div style={{ fontSize: 12.5, fontWeight: 700 }}>Juan Rodríguez</div>
            <div style={{ fontSize: 10.5, color: 'var(--text3)', fontWeight: 500 }}>Jefe de planta</div>
          </div>
        </div>
      </div>
    </nav>
  );
}
